import { render, staticRenderFns } from "./VersionSelector.vue?vue&type=template&id=75b68b4b"
import script from "./VersionSelector.vue?vue&type=script&lang=js"
export * from "./VersionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports